import React from 'react';

import { getProductFields, getProductFieldsPropTypes } from 'apps/analytics/components/pageComponentFields';
import PageComponent from 'apps/analytics/components/PageComponent';
import { componentFields, componentTypes, wa } from 'apps/analytics';
import PageComponentField from 'apps/analytics/components/PageComponentField';

export default function BopPageComponent({ product }) {
  if (!product) {
    return null;
  }

  const noThumbnail = !product.image;
  const id = `${wa.getPageViewId()}.BOP.${product.sku}`;

  return (
    <PageComponent
      id={id}
      type={componentTypes.BOP}
    >
      {getProductFields(product)}
      {noThumbnail && <PageComponentField field={componentFields.NO_THUMBNAIL} value key="nothumbnail" />}
    </PageComponent>
  );
}

BopPageComponent.propTypes = {
  ...getProductFieldsPropTypes,
};
